// extracted by mini-css-extract-plugin
export default {"tooltip":"TopicTreeMap_tooltip__LKL0R","brief":"TopicTreeMap_brief__WnAGu"};